// Metal Rates API Service
// This service provides static metal rates for static site export

export interface MetalRate {
  metal: string;
  price: number;
  change: number;
  changePercent: number;
  lastUpdate: string;
  unit: string;
}

export interface MetalRatesResponse {
  success: boolean;
  data: MetalRate[];
  timestamp: string;
  error?: string;
}

class MetalRatesApiService {
  private baseUrl: string;

  constructor(baseUrl: string = '') {
    this.baseUrl = baseUrl;
  }

  // Generate static data for metal rates
  private getStaticRates(): MetalRate[] {
    // Return static data for gold, silver and platinum
    return [
      {
        metal: 'Gold',
        price: 62500,
        change: 450,
        changePercent: 0.72,
        lastUpdate: new Date().toISOString(),
        unit: 'per 10g'
      },
      {
        metal: 'Silver',
        price: 75000,
        change: -250,
        changePercent: -0.33,
        lastUpdate: new Date().toISOString(),
        unit: 'per kg'
      },
      {
        metal: 'Platinum',
        price: 32000,
        change: 120,
        changePercent: 0.38,
        lastUpdate: new Date().toISOString(),
        unit: 'per 10g'
      }
    ];
  }

  // Main method to get metal rates
  async getMetalRates(): Promise<MetalRatesResponse> {
    console.log('Getting static metal rates');
    
    try {
      const data = this.getStaticRates();
      
      return {
        success: true,
        data,
        timestamp: new Date().toISOString()
      };
    } catch (error) {
      console.error('Error getting static metal rates:', error);
      
      // Return static data even on error
      return {
        success: false,
        data: [],
        timestamp: new Date().toISOString(),
        error: 'Failed to get metal rates'
      };
    }
  }

  // These methods are kept for API compatibility but don't change behavior
  setBaseUrl(url: string) {
    // Do nothing - no real API calls in static export
    console.log('setBaseUrl called, but not used in static export');
  }
}

// Create and export the service
export const metalRatesApiService = new MetalRatesApiService(); 